import React, { useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { mockData } from "../data/mockData";
import { Link } from "react-router-dom";

const ProjectsPage = () => {
  const [projects] = useState(mockData.allProjects);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white py-12">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mb-12"
        >
          <h1 className="text-4xl sm:text-5xl font-bold mb-4">All Projects</h1>
          <p className="text-[#a3a3a3] text-lg">
            Koleksi proyek yang telah saya kerjakan selama perjalanan belajar saya.
          </p>
        </motion.div>

        <motion.div
          className="space-y-2"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          {projects.map((project, index) => (
            <Link to={`/projects/${project.id}`} key={project.id}>
              <motion.div
                key={index}
                variants={cardVariants}
                whileHover={{ y: -4 }}
                className="mt-8 bg-neutral-900/50 border border-neutral-800 rounded-lg overflow-hidden group hover:border-[#3b82f6] transition-all duration-300 cursor-pointer"
              >
                <div className="relative overflow-hidden bg-neutral-950">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-64 sm:h-80 object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                </div>

                <div className="p-6 sm:p-8">
                  <div className="flex items-start justify-between mb-3">
                    <h2 className="text-2xl font-semibold group-hover:text-[#3b82f6] transition-colors">
                      {project.title}
                    </h2>
                    <ArrowRight
                      size={24}
                      className="text-[#a3a3a3] group-hover:text-[#3b82f6] group-hover:translate-x-1 transition-all flex-shrink-0 ml-4"
                    />
                  </div>

                  <p className="text-[#a3a3a3] leading-relaxed mb-4">
                    {project.description}
                  </p>

                  <div className="flex flex-wrap gap-2">
                    {project.technologies.map((tech, idx) => (
                      <span
                        key={idx}
                        className="text-xs px-3 py-1.5 bg-neutral-800 text-[#a3a3a3] rounded-full border border-neutral-700"
                      >
                        {tech}
                      </span>
                    ))}
                  </div>
                </div>
              </motion.div>
            </Link>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default ProjectsPage;
